
/*!
 * Module dependencies.
 */

'use strict';

const Binary = require('bson').Binary;

/*!
 * Module exports.
 */

module.exports = exports = Binary;



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/drivers/browser/binary.js
// module id = 332
// module chunks = 0